export default __webpack_public_path__ + "static/media/8c1ff208e968d8247081227e63030cf8.svg";